import AppWrapper from "./AppWrapper";
import { AppContainer } from "./StyledComponents";
import { AppRoutes } from "~/pages";



interface AppProps {
  className?: string;
}

export function App({ className }: Readonly<AppProps>) {
  return (
    <AppWrapper>
      <AppContainer
        className={className}
        data-testid="ui_general_app_container"
      >
        <AppRoutes />
      </AppContainer>
    </AppWrapper>
  );
}
